import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { isFunction, isString } from 'iotera-base/object';

import './style.scss'

export function ioteraConfirmAlert(title, question, yesAnswer, yesFunc, noAnswer, noFunc) {
  title = safeDeepGetWithType(title, [], 'Konfirmasi');
  question = safeDeepGet(question, [], 'Apakah anda yakin?');
  let textAi = '';
  let yesDisable = false
  let noDisable = false
  if (isString(question)) {
    if (question.includes('yakin')) {
      textAi = ', yakin'
    } else if (question.includes('pasti')) {
      textAi = ', pasti'
    } else if (question.includes('simpan')) {
      textAi = ', simpan'
    } else if (question.includes('hapus')) {
      textAi = ', hapus'
    }
  } else {
    textAi = ', yakin'
  }
  yesAnswer = safeDeepGetWithType(yesAnswer, [], 'Ya' + textAi);
  noAnswer = safeDeepGetWithType(noAnswer, [], 'Batal');
  let yesDisplay = 'block'
  let noDisplay = 'block'
  if (yesAnswer === 'gone')
    yesDisplay = 'none'
  if (noAnswer === 'gone')
    noDisplay = 'none'
  /* if for disable or enable yesAnswer, yesFunc must string not function and value must 'disable */
  if (!isFunction(yesFunc)) {
    if (yesFunc === 'disable') {
      yesDisable = true
    }
    else {
      yesDisable = false
      yesFunc = _ => console.log()
    }
  }
  /* end if for disable or enable yesAnswer */
  /* if for disable or enable noAnswer, noFunc must string not function and value must 'disable */
  if (!isFunction(noFunc)) {
    if (noFunc === 'disable') {
      noDisable = true
    }
    else {
      noDisable = false
      noFunc = _ => console.log()
    }
  }
  /* end for disable or enable noAnswer */
  return (
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body' style={{ zIndex: 1400 }}>
            <h4>{title}</h4>
            {question}
            <div className='react-confirm-alert-button-group' style={{ justifyContent: 'flex-end' }}>
              <button disabled={noDisable}
                onClick={() => {
                  onClose();
                  noFunc();
                }}
                style={{ backgroundColor: '#fff', color: '#4D2C91', display: noDisplay }}>
                {noAnswer}
              </button>
              <button disabled={yesDisable}
                onClick={() => {
                  onClose();
                  yesFunc();
                }}
                style={{ backgroundColor: '#4D2C91', display: yesDisplay }}>
                {yesAnswer}
              </button>
            </div>
          </div>
        );
      }
    })
  );
}